/** Image frame chrome. */
export default {
  loadingImages: "Loading images…",
  imageAlt: "Image {number}",
  noImagesYet: "No images yet",
} as const;
